<template>
  <!-- 篮球数据中心 -->
  <div class="sub-page">
    <div class="data-cemter">
      <div class="rank-tab">
        <div class="tab-list">
          <div class="tab-item" v-for="(item, index) in dataList" :key="index" @click="handleTab(item, index)">
            <div>{{ item.name }}</div>
            <div class="line" v-show="dataIndex == index"></div>
          </div>
        </div>
        <div class="select">
          <a-select class="select-item" @change="handleSeason" placeholder="选择赛季" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <a-select class="select-item" @change="handleSeason" placeholder="选择均场" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <a-select class="select-item" @change="handleSeason" placeholder="选择球队" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <a-select class="select-item" @change="handleSeason" placeholder="选择球员" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <div>
            <a-select class="select-item" @change="handleSeason" placeholder="场次" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          ~
          <a-select class="select-item" @change="handleSeason" placeholder="场次" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          </div>
         
        </div>
        <div class="row row-title">
          <div class="col-1">排名</div>
          <div class="col-2">球队</div>
          <div class="col-3">胜</div>
          <div class="col-4">负</div>
          <div class="col-5">胜场差</div>
          <div class="col-6">胜率(%)</div>
          <div class="col-7">积分</div>
          <div class="col-8">返10场</div>
          <div class="col-9">连胜/败</div>
          <div class="col-10">场均得分</div>
          <div class="col-11">场均失分</div>
          <div class="col-12">净胜分</div>
          <div class="col-13">主场</div>
          <div class="col-14">客场</div>
        </div>
        <div class="row" v-for="(item, index) in rowList" :key="index" :class="index % 2 == 1 ? 'active-bg' : ''" @click="paylerDetail">
          <div class="col-1">{{ index + 1 }}</div>
          <div class="col-2">{{ item.name }}</div>
          <div class="col-3">胜</div>
          <div class="col-4">负</div>
          <div class="col-5">胜场差</div>
          <div class="col-6">胜率(%)</div>
          <div class="col-7">积分</div>
          <div class="col-8">返10场</div>
          <div class="col-9">连胜/败</div>
          <div class="col-10">场均得分</div>
          <div class="col-11">场均失分</div>
          <div class="col-12">净胜分</div>
          <div class="col-13">主场</div>
          <div class="col-14">客场</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasketballDateCenter',
  props: {},
  data() {
    return {
      dataIndex: 0,
      dataList: [
        {
          name: '球员基础数据',
        },
        {
          name: '球员比赛统计',
        },
        {
          name: '球员高阶数据',
        },
        {
          name: '球队基础数据',
        },
        {
          name: '球队比赛统计',
        },
        {
          name: '球队高阶数据',
        },
      ],
      rowList: [
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
        { name: '球队名字' },
      ],
    }
  },
  components: {},
  mounted() {},
  methods: {
    handleTab(item, index) {
      this.dataIndex = index
    },
    //选择赛季
    handleSeason(e) {
      console.log('handleSeason', e)
    },
    paylerDetail() {
            this.$router.push({name:"BasketallPlayer"})
        }
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page {
  width: 100%;
  background-color: #f7f7f7;
  padding-top: 30px;
  .data-cemter {
    width: 1200px;
    margin: 0 auto;
    .tab-list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 10px;
      .tab-item {
        margin-right: 20px;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        cursor: pointer;
        .line {
          width: 100%;
          height: 4px;
          background-color: #aa1f23;
          margin-top: 8px;
        }
      }
    }
    .select {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
      .select-item {
        width: 140px;
        margin-right: 10px;
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      height: 60px;
      line-height: 60px;
      padding: 0 30px;
      .col-1 {
        width: 5%;
      }
      .col-2 {
        width: 10%;
      }
    }
    .active-bg {
      background-color: #e9e9e9;
    }
    .row-title {
      background-color: #000000;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballDateCenter.vue